export const defaultConfigState = {
  /**
   * Cờ đang xử lý
   */
  loading: false,
  /**
   * Danh sách báo cáo
   */
  reportList: null,
};

export default {
  ...defaultConfigState,
};
